module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp3_7005.ecf3af24.png";